/* =Toggle menu icon when drawer is open
-------------------------------------------------------------- */

$(document).ready(function(){
  (function($) {
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    $.fn.attrchange = function(callback) {
      if (MutationObserver) {
          var options = {
              subtree: false,
              attributes: true
          };

          var observer = new MutationObserver(function(mutations) {
              mutations.forEach(function(e) {
                  callback.call(e.target, e.attributeName);
              });
          });

          return this.each(function() {
              observer.observe(this, options);
          });
      }
    }
  })(jQuery);

  //Now you need to append event listener
  $('#PageContainer').attrchange(function(attrName) {
    var $node = $( this );
    if( $node.hasClass( "is-transitioning" ) ) {
      //console.log('open');
      $('#menu-icon').toggleClass('open');
      } else {
      //console.log('closed');
      $('#menu-icon').toggleClass('open');
    }

    if(attrName=='class'){
      //console.log('class changed');
    } else {
      //OTHER ATTR CHANGED
    }
  });
});

/* Thumbnail slider
--------------------*/
$(function() {
  $('.slider-thumbs').slick({
    arrows: true,
    autoplay: false,
    infinite: true,
    vertical: true,
    slidesToShow: 3,
    slidesToScroll: 3
  });

  $('.slider-related').slick({
    arrows: true,
    autoplay: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}); 

/* =FancyBox
-------------------------------------------------------------- */

$(function() {
  $('.fancybox').fancybox({
    padding: 0,
    margin: 40,
    helpers : {

      title : {
          type : 'outside'
      },

      overlay : {
        css : {
            'background' : 'rgba(255, 255, 255, 0.8)'
        }
      }
    }
  });
});

/* Sharing Popups
--------------------*/

$(".share-it").click(function(){
window.open($(this).attr("href"), 'social_share', 'height=288, width=750, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, directories=no, status=no');
return false;
}); 

/* Tutorials
--------------------*/

jQuery(document).ready(function($){
  // Find if there is a video and if there is, hide the featured image
  if ($('.tutorial-header .video-wrapper')[0]){
    $('.tutorial-header #featured-image').addClass('hide');
  } else {
    $('.tutorial-header #featured-image').addClass('show'); 
  }

  // Move the video to its own section
  $('.tutorial-header .video-wrapper').appendTo('#video');

  // Find small thumbs in tutorial content and replace them with large images
  $('.tutorial-content').find('img').attr('src', function(i, val) {
      return val.replace('_small', '_800x');
  });

  // Find nbsps which break the table layout and remove them
  $('.tutorial-content').each(function(){
    $(this).html($(this).html().replace(/&nbsp;/gi,''));
  });
});

/* Contact
--------------------*/

jQuery(document).ready(function($){
  $('.page-contact').each(function(){
    var inputBoxEcho = document.getElementById('ContactFormEmailConfirm');

    inputBoxEcho.onkeyup = function(){
      document.getElementById('confirm-email-note').innerHTML = 'Your reply will go to:';
      document.getElementById('confirm-email').innerHTML = inputBoxEcho.value;
    }
  });
});


 /* Product description toggles
--------------------*/

jQuery(document).ready(function($){
  // Loop through each H5 in the description
  $('.product-description.toggles h5').each(function(index, value){

    // For each H5, wrap everything from after the heading to just before the next one in a div with the class toggled-content
    $(this).nextUntil('h5').wrapAll('<div class="toggled-content">');

    // Give each h5 the class "toggle"
    $(this).addClass( 'toggle' );

    // Add tabindex=0 to make toggle keyboard accessible
    $(this).attr('tabindex', '0');
  });

  // Product description toggle links
  $('.product-description .toggled-content').hide();

  $('.product-description.toggles').find('.toggle').click(function(){
    // Set Google Analytics event
    ga('send', 'event', 'accordion', 'click', 'productTab');

    // Set this toggle to active
    $(this).toggleClass('active');

    // Remove active class on inactive toggles
    $(".toggle").not($(this)).removeClass( 'active' );

    // Expand or collapse this panel
    $(this).next().slideToggle('fast');

    // Hide the other panels
    $(".toggled-content").not($(this).next()).slideUp('slow');
  });

  // Wrap the whole list and the tab content divs in a surrounding div
  $('.product-description-short .toggle, .product-description-short .toggled-content').wrapAll('<div class="product-tab-area" />');

  // Move that surrounding div to the tabs section
  $('.product-tab-area').appendTo('.product-description-tabs');

  // Make toggles keyboard accessible
  $('.product-tab-area').find('.toggle').keydown(function(e){
      if(e.which == 40){ // down arrow key
          e.preventDefault();
          $(this).click();
      }
  });
});

/* Hide zoom effect when Lifter pop-up is open
--------------------*/


  (function($) {
    $(document).ready(function() {
      var $fancyboxPopup = $('.fancyboxPop-opened');
      var popupLoaded = false;
      var popupClosed = false;
      
      var popupTimer = setInterval(function() {      
        var $fancyboxPopup = $('.fancyboxPop-opened');
        //console.log($fancyboxPopup, popupLoaded, popupClosed);
        
        if ($fancyboxPopup.length === 0) {
          $('#PageContainer').addClass('zoom-enabled');
        }
        else {
          $('#PageContainer').removeClass('zoom-enabled');
          popupLoaded = true;
        }

        // Check if Popup was Closed
        if (popupLoaded && $fancyboxPopup.length === 0) {
          popupClosed = true;
        }
        
        // Clear popupTimer
        if (popupClosed) {
          clearInterval(popupTimer);
        }
      }, 500);
    });
  })(jQuery);
